export interface CustomerChargeAndCredit {
	id: string;
	name: string;
	displayName?: string;
	type: ChargeType;
	displayAmount: number;
	includedAmount: number;
	excludedAmount: number;
	activatedAt: string;
	terminatedAt?: string;
}

enum ChargeType {
	ONCE_ONLY_CHARGE = "ONCE_ONLY_CHARGE",
	RECURRING_CHARGE = "RECURRING_CHARGE"
}

export interface CreateCustomerChargeOrCreditDto {
	name: string;
	invoiceText?: string;
	startDate?: string;
	includedAmount?: string;
}

export interface AvailableOnceOnlyChargeOrCreditDto {
	name: string;
	displayName: string;
	displayDescription: string;
	amountAdjustmentAllowed: boolean;
	billTextAdjustmentAllowed: boolean;
	includedAmount: number;
	excludedAmount: number;
}

export interface CustomerAvailableChargesAndCreditsDto {
	onceOnlyCharges: AvailableOnceOnlyChargeOrCreditDto[];
	onceOnlyCredits: AvailableOnceOnlyChargeOrCreditDto[];
}
